import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { onError } from "../libs/errorLib";

import pLimit from 'p-limit';

import { API } from "aws-amplify";
import "./VisitorBook.css";
//import LoaderButton2 from "../components/LoaderButton2";
//import LoaderButton3 from "../components/LoaderButton3";

import NumberSpinner from "../components/NumberSpinner";

import LoaderButtonX from "../components/LoaderButtonX";

import RuleInput from "../components/RuleInput"


import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import { BsArrowRepeat } from "react-icons/bs";


import Table from "react-bootstrap/Table";

import { makeStyles, withStyles, styled } from '@material-ui/core/styles';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AddIcon from '@material-ui/icons/AddCircleOutlineRounded';
import CancelIcon from '@material-ui/icons/Cancel';
import ArtifactingIcon from '@material-ui/icons/FormatListNumbered';
import ExtractionIcon from '@material-ui/icons/Grain';
import FlareIcon from '@material-ui/icons/Flare';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SyncIcon from '@material-ui/icons/Sync';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';


import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';




import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import Button from '@material-ui/core/Button';
//import Button from "../components/LoaderButtonX";
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';

import ButtonBase from '@material-ui/core/ButtonBase';


import Fab from '@material-ui/core/Fab';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Chip from '@material-ui/core/Chip';
//import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

//import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
//import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
//import Brightness3Icon from '@material-ui/icons/Brightness3';
//import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

//import PictureAsPdfRoundedIcon from '@material-ui/icons/PictureAsPdfRounded';

import iTopOvernightOff from '../images/preview/Pay Per Night - Grey.svg';
import iTopBaysOff from '../images/preview/Parking - Grey.svg';
import iTopFacilitiesOff from '../images/preview/Facilities Only - Grey.svg';

import iTopOvernight from '../images/preview/Pay Per Night - Blue.svg';
import iTopBays from '../images/preview/Parking - Blue.svg';
import iTopFacilities from '../images/preview/Facilities Only - Blue.svg';


import iRecyclingOff from '../images/facilities/Recycling - Grey.svg';
import iBlackWaterOff from '../images/facilities/Black Water Disposal - Grey.svg';
import iElectricOff from '../images/facilities/Electric Hook Up - Grey.svg';
import iGreyWaterOff from '../images/facilities/Grey Water Disposal - Grey.svg';
import iLaundryOff from '../images/facilities/Laundry - Grey.svg';
import iOvernightOff from '../images/facilities/Overnight Parking - Grey.svg';
import iRubbishOff from '../images/facilities/Rubbish - Grey.svg';
import iShowerOff from '../images/facilities/Shower - Grey.svg';
import iToiletOff from '../images/facilities/Toilet - Grey.svg';
import iWaterOff from '../images/facilities/Water - Grey.svg';
import iWifiOff from '../images/facilities/Wifi - Grey.svg';

import iRecycling from '../images/facilities/Recycling - Coral.svg';
import iBlackWater from '../images/facilities/Black Water Disposal - Coral.svg';
import iElectric from '../images/facilities/Electric Hook Up - Coral.svg';
import iGreyWater from '../images/facilities/Grey Water Disposal - Coral.svg';
import iLaundry from '../images/facilities/Laundry - Coral.svg';
import iOvernight from '../images/facilities/Overnight Parking - Coral.svg';
import iRubbish from '../images/facilities/Rubbish - Coral.svg';
import iShower from '../images/facilities/Shower - Coral.svg';
import iToilet from '../images/facilities/Toilet - Coral.svg';
import iWater from '../images/facilities/Water - Coral.svg';
import iWifi from '../images/facilities/Wifi - Coral.svg';



import iCampra from '../images/campra/Campra Accredited - Green.svg';

import defaultSiteImage from '../images/Default-Image-Road.jpg';
import spinner from '../images/Driving-SVG.gif';


import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import Container from '@material-ui/core/Container';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';


import Form from "react-bootstrap/Form";

import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';

import parse from 'html-react-parser';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import iLogo from "../images/logo.jpg";
import iQRLogo from "../images/qrcode_logo.svg";

import iCampraA from '../images/campra/Campra Accredited - Green.svg';
import iCampraX from '../images/campra/Campra Accredited - Grey.svg';


import QRCode from 'qrcode';
import { createCanvas, loadImage } from "node-canvas";

import '../fonts/Montserrat-Regular-normal.js';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';


//import Calendar from 'react-calendar';
//import 'react-calendar/dist/Calendar.css';

//import CalendarPicker from 'react-native-calendar-picker';

//import DatePicker from "react-multi-date-picker";
//import { Calendar, DateObject } from "react-multi-date-picker"
////import "react-multi-date-picker/styles/colors/xxx.css"
//import "react-multi-date-picker/styles/colors/red.css"
//import colors from "react-multi-date-picker/plugins/colors"

//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import DateRangeIcon from '@material-ui/icons/DateRange';
//import Collapse from '@material-ui/core/Collapse';


//import Papa from 'papaparse';


//import DownloadCSV from '../components/DownloadCSV';




//import {LlamaParseReader} from "llamaindex";
//import 'dotenv/config'




export default function QX() {


  const history = useHistory();
  const location = useLocation();
  //const { userHasAuthenticated, isAuthenticated, isCampra, setShowSites} = useAppContext();


  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));

  const { project } = location.state || {};
  //console.log(project);

  const [fields, handleFieldChange] = useFormFields({
    email: "",
    reg: "",
  });
  const [tncs, setTncs] = useState(false);

  const { isAuthenticated, isCampra } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);
  const [switchingId, setSwitchingId] = useState(null);

  const [open, setOpen] = React.useState([]);
  const [paymentResult, setPaymentResult] = React.useState(false);
  const [sessionValues, setSessionValues] = React.useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const [alertVals, handleAlertChange] = useFormFields({
    title: "",
    message: "",
  });



  const [currentSite, setCurrentSite] = useState(null);
  const [content, setContent] = useState("");
  const [siteOpen, setSiteOpen] = useState(false);
  //const [base64Image, setBase64Image] = useState("");
  //const [siteCode, setSiteCode] = useState("");
  //const [desc, setDesc] = useState("");
  //const [rules, setRules] = useState("");
  const [address, setAddress] = useState("");
  //const [accreditations, setAccreditations] = useState([]);


  const [sites, setSites] = useState([]);



  const [calendarVal, onCalendarVal] = useState([
    //new DateObject().setDay(5),
    ///new DateObject().setDay(12).color="red",
    //new DateObject().setDay(14).add(1, "month"),
    //new DateObject().setDay(23).add(1, "month"),

  ]);

  const [closedDatesChanged, setClosedDatesChanged] = React.useState([]);
  const [calendarExpanded, setCalendarExpanded] = React.useState([]);
  const handleExpandCalendarClick = (idx) => {
    const curr = calendarExpanded[idx];
    let newArr = new Array(calendarExpanded.length).fill(false);
    newArr[idx] = !curr;
    setCalendarExpanded(newArr);
  };


  const [forceUpdate, setForceUpdate] = React.useState(false);

  const [dateRange, setDateRange] = useState([
    //new DateObject()
  ])

  //const [isUploading, setIsUploading] = useState(false);
  const [isReadyToUpload, setIsReadyToUpload] = useState(false);

  const [temperature, setTemperature] = useState(0.0);
  const [topP, setTopP] = useState(1.0);
  const [presencePenalty, setPresencePenalty] = useState(0.0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);


  const [docTitle, setDocTitle] = useState("");
  const [docDesc, setDocDesc] = useState("");

  const [docFile, setDocFile] = useState(null);


  const [uploadStatus, setUploadStatus] = useState({ regenArtifacts: false, regenSdos: false, isFreeQuerying: true, isQuerying: false, isComplete: false, isUploading: false, isArtefacting: false, isParsing: false, isMetadating: false, isExtracting: false, parsingStatus: '', artefactingStatus: '', extractingStatus: '', resultsStatus: '', startTime: 0 });
  const uploadStatusRef = useRef(uploadStatus);

  const [jobId, setJobId] = useState(null);
  const [docId, setDocId] = useState(null);
  //const [isParsing, setIsParsing] = useState(false);
  //const [parsingStatus, setParsingStatus] = useState('');



  //const parsingStatusRef = useRef(parsingStatus);
  //const [isComplete, setIsComplete] = useState(false);
  //const [isArtefacting, setIsArtefacting] = useState(false);
  //const [artifactingStatus, setArtifactingStatus] = useState('');
  //const artefactingStatusRef = useRef(artifactingStatus);  


  //const [isExtracting, setIsExtracting] = useState(false);
  //const [extractingStatus, setExtractingStatus] = useState('');
  //const extractingStatusRef = useRef(extractingStatus);




  const [parsedData, setParsedData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState("");
  const [selectedModel, setSelectedModel] = useState('gpt-4.1-mini');

  const [selectedParseModel, setSelectedParseModel] = useState('gpt-4.1-mini');
  const [selectedArtefactModel, setSelectedArtefactModel] = useState('gpt-4.1-mini');
  const [selectedExtractModel, setSelectedExtractModel] = useState('gpt-4.1-mini');


  const [parOpen, setParOpen] = useState(false);
  const [artOpen, setArtOpen] = useState(false);
  const [extOpen, setExtOpen] = useState(false);
  const [resOpen, setResOpen] = useState(false);

  const [resultsTitle, setResultsTitle] = useState('');
  const [resultsData, setResultsData] = useState('');

  const [fullCats, setFullCats] = useState([]);


  const [openaiData, setOpenaiData] = useState("");
  const [prompt, setPrompt] = useState("");
  const [sysPrompt, setSysPrompt] = useState("");

  const [copied, setCopied] = useState(false);

  const [parsePromptUser, setParsePromptUser] = useState("");
  const [parsePromptSys, setParsePromptSys] = useState("");

  const [warnRegenerate, setWarnRegenerate] = useState(false);


  const [artePromptUser, setArtePromptUser] = useState("");
  const [artePromptSys, setArtePromptSys] = useState("");

  const [extractPromptUser, setExtractPromptUser] = useState("");
  const [extractPromptSys, setExtractPromptSys] = useState("");

  const [metaPromptUser, setMetaPromptUser] = useState("");
  const [metaPromptSys, setMetaPromptSys] = useState("");

  const [artPageNo, setArtPageNo] = useState(4);

  const [version, setVersion] = useState(0);


  const [fileUrl, setFileUrl] = useState(null);


  const [instanceKey, setInstanceKey] = useState(0); // for categoryinput component

  const [categories, setCategories] = useState([]);
  const [catCols, setCatCols] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [categoryData, setCategoryData] = React.useState([]);

  const [models, setModels] = useState([]);

  const handleTopPChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTopP(newValue);
  }
  const handleTemperatureChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTemperature(newValue);
  }
  const handlePresencePenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setPresencePenalty(newValue);
  }
  const handleFrequencyPenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setFrequencyPenalty(newValue);
  }


  /*const models = [
    { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
    { value: 'gpt-4.1', label: 'GPT-4.1' },
    { value: 'gpt-4o', label: 'gpt-4o' },
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' }
  ];*/


  /*
    2.⁠ ⁠Output: JSON array of artefacts with:
  o	id: Unique number
  o	title: Brief descriptive title
  o	md: Compressed markdown using bullets/short blocks
  o	categories: Tags from provided scheme
  */

  const jsonOutputExtracting = `
{
"field": "Field Name from List",
"value": 123,
"units": "Specify (e.g., USD million)",
"period": "Specify (e.g., FY 2023)",
"source_artefact_reference": "Brief reference (e.g., Note 5 - Debt)",
"company_term_if_different": "Company wording if differs from field name",
"artifactId": 123 (from id)
}`;

  const jsonOutputArtefacting = `
{
"id": 113 (Sequential numeric ID)
"page": 123 (Original page number)
"title": "Brief descriptive title"
"md": "Compressed markdown summary using bullets or short blocks"
"categories": [] Array of one or more sub-category IDs from the taxonomy
}`;

  const categoriesStr = `{
"1": {"title": "Transaction Overview",
"subsections":{
"1.1":{"title": "Notices, Contacts and Administrative matters re this document"},
"1.2":{"title": "Deal Summary"},
"1.3":{"title": "Use of Proceeds"},
"1.4":{"title": "Sources & Uses"},
"1.5":{"title": "Capital Structure"}
}
},
"2": {"title": "Company Profile",
"subsections":{
"2.1":{"title": "Business Overview"},
"2.2":{"title": "Corporate History"},
"2.3":{"title": "Legal Structure"},
"2.4":{"title": "Ownership & Sponsors"}
}
},
"3": {"title": "Industry & Market",
"subsections":{
"3.1":{"title": "Industry Overview"},
"3.2":{"title": "Market Position"},
"3.3":{"title": "Competitive Landscape"}
}
},
"4": {"title": "Products & Services",
"subsections":{
"4.1":{"title": "Product/Service Portfolio"},
"4.2":{"title": "Customer Segments"},
"4.3":{"title": "Sales Channels & Distribution"}
}
},
"5": {"title": "Operations",
"subsections":{
"5.1":{"title": "Operational Footprint"},
"5.2":{"title": "Facilities & Assets"},
"5.3":{"title": "Supply Chain & Procurement"}
}
},
"6": {"title": "Management & Employees",
"subsections":{
"6.1":{"title": "Management Team"},
"6.2":{"title": "Organizational Structure"},
"6.3":{"title": "Human Resources"}
}
},
"7": {"title": "Financials",
"subsections":{
"7.1":{"title": "Historical Financials"},
"7.2":{"title": "Pro Forma Financials"},
"7.3":{"title": "Financial Projections"},
"7.4":{"title": "KPIs & Financial Metrics"}
}
},
"8": {"title": "Debt & Liabilities",
"subsections":{
"8.1":{"title": "Existing Debt"},
"8.2":{"title": "New Debt Terms"},
"8.3":{"title": "Debt Maturities"},
"8.4":{"title": "Covenants & Restrictions"}
}
},
"9": {"title": "Risk Factors",
"subsections":{
"9.1":{"title": "Operational Risks"},
"9.2":{"title": "Market Risks"},
"9.3":{"title": "Regulatory & Legal Risks"}
}
},
"10": {"title": "Legal & Compliance",
"subsections":{
"10.1":{"title": "Litigation"},
"10.2":{"title": "Regulatory Environment"},
"10.3":{"title": "Compliance & Permits"}
}
}
}`;




  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);



  const handleCategoryCheckboxChange = (e) => {
    const key = parseInt(e.target.value, 10);
    const checked = e.target.checked;

    setSelectedCategories((prev) =>
      checked ? [...prev, key] : prev.filter((k) => k !== key)
    );

  };


  const handleSelectDocument = (e) => {
    e.preventDefault();
    console.log(fullCats);
    setSelectedDoc(e.target.value)
    const doc = documents[e.target.value];
    const cats = JSON.parse(doc.content);
    let catOpts = [];
    //let colArr = [3];
    let idx = 0;
    let catidx = 0;
    for (const cat in fullCats) {
      //console.log(cat);
      const col = catidx < 3 ? 0 : catidx < 7 ? 1 : 2;
      catOpts.push({ key: idx, label: cat + " " + fullCats[cat].title, artefactIds: null, status: 0, col: col });
      idx++;
      catidx++;
      //console.log(catOpts);
      for (const subcat in fullCats[cat].subsections) {
        //console.log(subcat + " " + fullCats[cat].subsections[subcat].title);
        //console.log(cats[subcat]);
        const items = cats[subcat];
        catOpts.push({ key: idx, label: subcat + " " + fullCats[cat].subsections[subcat].title, artefactIds: items, status: items ? 1 : 9, col: col });
        idx++;
      }
    }
    const colArr = Array.from({ length: 3 }, () => []);
    catOpts.forEach((catItem, index) => {
      //console.log(catItem);
      colArr[catItem.col].push(catItem);
    });
    setCatCols(colArr);
    setCategories(catOpts);
  };



  function handleAddCategoryClick() {
    categories.unshift(newCategory);
    categoryData.splice(0, categoryData.length)
    categories.map((cat, index) => {
      categoryData.push({ key: index, label: cat });
    })
    setInstanceKey(i => i + 1);
    setNewCategory("");
  }


  const newCategoryHandler = data => { setNewCategory(data.category) }



  const handleDeleteCategory = (categoryToDelete) => () => {
    setCategoryData((categories) => categories.filter((cat) => cat.key !== categoryToDelete.key));
  };


  useEffect(() => {
    onLoad();
  }, []);


  async function onLoad() {
    if (!isAuthenticated) { history.push("/"); return; }
    loadModels();
    //if (project == undefined) {history.push("/"); return;}
    //getDocs("", false);
    //loadConfig();
  }


  const loadModels = async () => {

    const result = await getResults({ pk: "LOOKUP", sk: "MODL", mode: "get" });
    let modLookup = [];
    if (result.status && result.data) {
      modLookup = result.data.content.rows.map(row =>
        Object.fromEntries(result.data.content.columns.map((h, i) => [h.trim(), row[i].trim()]))
      );
    }
    setModels(modLookup);

  }
  function getResults(body) {
    return API.post("findigai", "/results/mode", {
      body: body
    });
  }
  ///////////////// UPLOADER //////////////////////////

  function createSite(site) {
    return API.post("aires", "/sites", {
      body: site
    });
  }
  async function buildSite(content) {
    try {
      //console.log(content);
      //const result = await createSite({ content: content, image: "", itemStatus: 8}); // itemStatus -> DEfault = 8 (i.e. NON-Airestop site)
      return true;
    } catch (e) {
      onError(e);
      return false;
    }


  }


  var datafiles;
  var fileIndex = 0;

  const handleFile = e => {
    const content = e.target.result;








    /*
      try {
        const result = await uploadData({ aaa:111});
        readNextFile();
      } catch (e) {
        onError(e);
        setIsUploading(false);
      }
        */
  }
  /*
  function readNextFile() {
    fileIndex += 1;
    if (fileIndex >= datafiles.length) {
      setIsUploading(false);
      return;
    }
    var reader = new FileReader();
    reader.onloadend = handleFile;
    var f = datafiles[fileIndex];
    reader.readAsText(f);
  }
    */



  /*
    function readNextFile() {
      //console.log(datafiles);
      fileIndex += 1;
      if (fileIndex >= datafiles.length) {
        setIsUploading(false);
        return;
      }
      var reader = new FileReader();
      reader.onloadend = handleFile;
      var f = datafiles[fileIndex];
      reader.readAsText(f);
    }
    */





  function uploadData(data) {
    //console.log(data);

    return API.post("spivolaaatsss", "/org/sitesaaaaaaaaaa", {
      body: data
    });

  }

  function parseDoc(body) {
    return API.post("findigai", "/parse", {
      body: body
    });
  }



  function updateConfig(body) {
    return API.patch("findigai", "/config", {
      body: body
    });
  }

  function getConfig() {
    return API.get("findigai", "/config");
  }


  function uploadDoc(body) {
    return API.post("findigai", "/documents/create", {
      body: body
    });
  }

  function getArtefacts() {
    const docid = selectedDocument.itemId;
    return API.get("findigai", "/artefacts/" + docid);
  }

  function deleteArtefacts(sk) {
    const docid = selectedDocument.itemId;
    return API.del("findigai", "/artefacts/" + docid + "/" + sk);
  }


  function getSdos() {
    const docid = selectedDocument.itemId;
    return API.get("findigai", "/sdos/" + docid);
  }

  function updateDocument(body) {
    return API.put("findigai", "/documents", {
      body: body
    });
  }

  function getDocuments() {
    return API.get("findigai", "/documents/" + project.itemId);
  }
  function getDocument(id) {
    return API.get("findigai", "/documents/" + project.itemId + "/" + id);
  }
  function getOpenAI(body) {
    return API.post("findigai", "/openai", {
      body: body
    });
  }


  const saveConfig = async () => {
    console.log(artPageNo);
    setVersion(v => v + 1);
    const cats = JSON.parse(categoriesStr);
    //console.log(cats);
    const body = { artCategories: cats, outputs: { artefact: jsonOutputArtefacting, sdo: jsonOutputExtracting }, options: { metaPromptUser: metaPromptUser, metaPromptSys: metaPromptSys, artePromptUser: artePromptUser, artePromptSys: artePromptSys, parsePromptSys: parsePromptSys, parsePromptUser: parsePromptUser, extractPromptSys: extractPromptSys, extractPromptUser: extractPromptUser, selectedArtefactModel: selectedArtefactModel, selectedParseModel: selectedParseModel, selectedExtractModel: selectedExtractModel, chunkSize: artPageNo } };
    const result = await updateConfig(body);
    console.log(artPageNo);
  }




  const pollParsingStatus = async () => {
    if (uploadStatus.isParsing) {
      //console.log("polling c");

      try {
        if (uploadStatusRef.current.isMetadating) {
          const result = await getDocument(docId);
          if (result.document.itemStatus == 1) {
            const secs = (Date.now() - uploadStatusRef.current.startTime) / 1000;
            setUploadStatus(prev => ({
              ...prev,
              isParsing: false,
              isUploading: false,
              isMetadating: false,
              /*parsingStatus: uploadStatusRef.current.parsingStatus+"complete!",*/
              resultsStatus: "uploaded & parsed (" + secs.toFixed(0) + " seconds)"
            }));
            getDocs(docId, true);
            setIsReadyToUpload(false);
            setResOpen(true);
          }
        } else {
          if (!jobId) return;
          const resultJob = await parseDoc({ type: "job", id: jobId });
          console.log(resultJob)
          const { status } = resultJob.data;
          //setParsingStatus(status);

          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            if (status === "SUCCESS") {



              setUploadStatus(prev => ({
                ...prev,
                isMetadating: true,
                resultsStatus: uploadStatusRef.current.resultsStatus + "metadata"
              }));
              //getDocs(docId);



              /*
              setUploadStatus(prev => ({
                ...prev,
                isParsing: false,
                isArtefacting: true,
                parsingStatus: uploadStatusRef.current.parsingStatus+"complete!"
              }));
              artifactise();
              */
            } else {
              console.log("DOC PARSING FAILED: ", status)
              //setIsUploading(false);

              setUploadStatus(prev => ({
                ...prev,
                isUploading: false
              }));

            }
          }
        }
      } catch (error) {
        console.error('Error checking parsing status:', error);
        //setIsUploading(false);

        setUploadStatus(prev => ({
          ...prev,
          isUploading: false
        }));

      }
    }
  };

  // Set up a polling mechanism that checks every 5 seconds until completed
  useEffect(() => {
    //console.log("polling");
    let pollingInterval;

    if (uploadStatus.isParsing) {
      //console.log("YYY ", uploadStatus);
      pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [uploadStatus.isParsing, jobId]); //.isParsing

  /*
  useEffect(() => {
    parsingStatusRef.current = parsingStatus;
  }, [parsingStatus]);
  useEffect(() => {
    artefactingStatusRef.current = artifactingStatus;
  }, [artifactingStatus]);
*/
  useEffect(() => {
    //console.log(uploadStatus);
    uploadStatusRef.current = uploadStatus;
  }, [uploadStatus]);



  useEffect(() => {
    //console.log("pollingxx");
    let pollingInterval;

    if (uploadStatus.isUploading) {
      //console.log("XXX ", uploadStatus);
      pollingInterval = setInterval(updateParsingStatus, 1000); // Check every 5 seconds
    }
    try {
      return () => {
        clearInterval(pollingInterval);
      } // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [uploadStatus.isUploading]); //

  const updateParsingStatus = () => {
    //console.log(">>> ",uploadStatus);
    //console.log("===",uploadStatusRef.current);
    if (!uploadStatusRef.current.isComplete) {
      if (uploadStatusRef.current.isArtefacting) {
        //console.log("isArtefacting");
        //let val =  artefactingStatusRef.current+".";
        // setArtifactingStatus(val);

        setUploadStatus(prev => ({
          ...prev,
          /*artefactingStatus: uploadStatusRef.current.artefactingStatus+".",*/
          resultsStatus: uploadStatusRef.current.resultsStatus + "."
        }));

      } else if (uploadStatusRef.current.isParsing) {
        //console.log("isParsing");
        //let val =  parsingStatusRef.current+".";
        //setParsingStatus(val);

        setUploadStatus(prev => ({
          ...prev,
          /*parsingStatus: uploadStatusRef.current.parsingStatus+".",*/
          resultsStatus: uploadStatusRef.current.resultsStatus + "."
        }));

      } else if (uploadStatusRef.current.isUploading) {

        setUploadStatus(prev => ({
          ...prev,
          /*parsingStatus: uploadStatusRef.current.parsingStatus+".",*/
          resultsStatus: uploadStatusRef.current.resultsStatus + "."
        }));




        //let val =  parsingStatusRef.current+".";
        //setParsingStatus(val);
      }
    }
    //console.log(parsingStatus);
  }

  /*
  useEffect(() => {
    console.log("polling art");
    let pollingInterval;

    if (isArtefacting) {
      console.log("polling art b");
      pollingInterval = setInterval(pollArtefactisationStatus, 5000); // Check every 5 seconds
    }
    try{
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch(e) {
      // do nowt
    }
    
  }, [isArtefacting, docId]);
*/




  const handleDocChange = async (event) => {
    event.preventDefault();
    resetResults();
    cancelAll(event);


    //console.log(event);
    //setSelectedDocument(event.target.value)
    const seldoc = documents.filter(doc => doc.itemId == event.target.value);
    setSelectedDocument(seldoc[0]);
    //console.log(seldoc);

  }


  const handleUploadClick = async (event) => {
    event.preventDefault();
    if (uploadStatus.isUploading) {
      return;
    }
    //console.log(event.target.files.length);
    if (event.target.files.length == 0) {
      return;
    }

    const file = event.target.files[0];
    //const result = await getDocuments();
    let isDuplicate = false;
    let version = 0;
    for (const doc of documents) {
      if (doc.name == file.name) {
        isDuplicate = true;
        if (doc.version && doc.version > version) {
          version = doc.version;
        }
      }
    }
    version++;
    setFileDetails({ file: file, version: version, isDuplicate: isDuplicate });
    const newDoc = { itemId: "NEW", name: file.name, version: version };
    setDocuments(prevItems => [...prevItems, newDoc]);
    setSelectedDocument(newDoc);
    if (!isDuplicate) {
      setIsReadyToUpload(true);
    }
  }





  const continueRegenerate = async (event) => {
    event.preventDefault();
    resetResults();
    setWarnRegenerate(false);
    saveConfig();
    setUploadStatus(prev => ({
      ...prev,
      isUploading: true,
      resultsStatus: "deleting",
      startTime: Date.now()
    }));
    let sk = "";
    if (uploadStatus.regenArtifacts) {
      sk = 'ART|';
    } else {
      sk = 'ART|SDO|';
    }
    const result = await deleteArtefacts(sk);
    if (result.status && result.isComplete) {
      if (uploadStatus.regenArtifacts) {
        artifactise2(true);
      } else {
        sdoExtraction(true);
      }
    } else {
      alert("Unable to delete all, please try again");
      setUploadStatus(prev => ({
        ...prev,
        isUploading: false,
        resultsStatus: ""
      }));
    }
  }





  const continueFileUpload = (event) => {
    event.preventDefault();
    setIsReadyToUpload(true);
  }


  const uploadParseDoc = async () => {
    setUploadStatus(prev => ({
      ...prev,
      isUploading: true,
      resultsStatus: "uploading",
      startTime: Date.now()
    }));


    fileIndex = -1;
    const file = fileDetails.file;
    const version = fileDetails.version;
    setFileDetails(null);
    //console.log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = async () => {
      const base64String = reader.result.split(',')[1]; // Get base64 data
      try {
        parseDoc({ projectId: project.itemId, doc: base64String, fileName: file.name, version: version })
          .then(resultParse => {
            //console.log("Got data:", resultParse);
            const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
            setDocId(resultParse.docId);
            const { id, status } = data;
            //setParsingStatus(status);
            setJobId(id);
            //setIsParsing(true);

            setUploadStatus(prev => ({
              ...prev,
              isParsing: true,
              resultsStatus: uploadStatusRef.current.resultsStatus + "parsing"
            }));


            setFileUrl(resultParse.location);
          })
          .catch(err => {
            console.error('Error uploading file:', err);
          });
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    };
  }






  function buildHierarchy(parsedJson) {
    const hierarchy = [];
    const stack = [{ level: 0, children: hierarchy }]; // Root container

    parsedJson.forEach((item) => {
      const match = item.text.match(/^(#+)\s*(.*)/); // Detect Markdown-style headers

      if (match) {
        const level = match[1].length; // Number of '#' determines heading level
        const title = match[2];

        const newNode = { title, level, children: [] };

        // Find the correct parent in the stack
        while (stack.length && stack[stack.length - 1].level >= level) {
          stack.pop();
        }

        stack[stack.length - 1].children.push(newNode);
        stack.push(newNode);
      }
    });

    return hierarchy;
  }


  function renderLoader() {
    return (
      <div id="splash" style={{ paddingTop: 100, zIndex: 999 }}>

        <center id="splash">
          <img src={spinner} height="30px" width="auto" />
          {/*}<Typography style={{padding: '4px'}} variant="caption">{label}</Typography>*/}
        </center>
      </div>


    );

  }
  const getJob = async (e) => {
    e.preventDefault();
    if (jobId != "") {
      //const resultJobData = await parseDoc({type: "jobresult", id: jobId, output:"json"});
      const resultJobData = await parseDoc({ type: "reformat", id: jobId, output: "json" });
      //console.log(resultJobData)
      setParsedData(resultJobData.data);
    }
  }



  async function getSDOList() {
    //const getSDOList = async () => {
    const sdos = await getSdos();
    console.log(sdos); // id md content
    let resultsStr = "";
    for (const sdo of sdos.data) {
      resultsStr += "id: " + String(sdo.itemId) + "\n";
      resultsStr += "field: " + String(sdo.content.field) + "\n";
      resultsStr += "period: " + String(sdo.content.period) + "\n";
      resultsStr += "units: " + String(sdo.content.units) + "\n";
      resultsStr += "value: " + String(sdo.content.value) + "\n";
      resultsStr += "company_term_if_different: " + String(sdo.content.company_term_if_different) + "\n";
      resultsStr += "source_artefact_reference: " + String(sdo.content.source_artefact_reference) + "\n";
      resultsStr += "artifactId: " + String(sdo.content.artefactId) + "\n\n";
      resultsStr += "---------------------------------------------------------------------------------------------------------------------\n\n";
    }
    return resultsStr;
  }




  const sdoExtraction = async (isRegen) => {
    if (isRegen) {
      setUploadStatus(prev => ({
        ...prev,
        resultsStatus: uploadStatus.resultsStatus + "extracting"
      }));
    } else {
      setUploadStatus(prev => ({
        ...prev,
        resultsStatus: "extracting",
        startTime: Date.now(),
        isUploading: true
      }));
    }
    const result = await getOpenAI({ type: 'sdoextraction', prjid: project.itemId, docid: selectedDocument.itemId });
    console.log(result);
    const secs = (Date.now() - uploadStatusRef.current.startTime) / 1000;
    setUploadStatus(prev => ({
      ...prev,
      isExtracting: false,
      isUploading: false,
      regenArtifacts: false,
      regenSdos: true,
      resultsStatus: "SDOs extracted (" + secs.toFixed(0) + " seconds)"
    }));
    const resultsStr = await getSDOList();
    setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Structured Data Objects");
    getDocs(selectedDocument.itemId, false);
    setResultsData(resultsStr);
    setResOpen(true);
  }

  const artifactise2 = async (isRegen) => {

    if (isRegen) {


      setUploadStatus(prev => ({
        ...prev,
        resultsStatus: uploadStatus.resultsStatus + "artefacting"
      }));
    } else {
      setUploadStatus(prev => ({
        ...prev,
        resultsStatus: "artefacting",
        startTime: Date.now(),
        isUploading: true
      }));
    }



    //const pageNumbers = selectedDocument.parseState.pageNumbers;
    let chunkSize = artPageNo;
    let status = 1;
    let resultsStr = "";
    const attempts = 4;

    while (status <= attempts) {
      console.log("attempt: ", status, " chunkSize: ", chunkSize);
      const batchResults = await batchArtefactise(chunkSize);

      if (batchResults.success) {

        //console.log(batchResults.data);
        const pageNumbers = batchResults.pageNumbers;
        const pageCount = batchResults.pageCount;

        batchResults.data.forEach((result) => {
          console.log(result);
          if (result.statusCode === 200) {
            // If successful, update the selected pages in updatedPageNumbers
            result.pages.forEach(page => {
              console.log(page);
              const pageIndex = pageNumbers.findIndex(pageObj => pageObj.page === page);
              console.log(page, pageIndex);
              if (pageIndex !== -1) {
                pageNumbers[pageIndex].artefactised = true;
                console.log(pageIndex, true);
              }
            });
          }
        });

        console.log(pageNumbers);
        const hasNonArtefactised = pageNumbers.some(page => !page.artefactised);

        if (hasNonArtefactised) { // Not completed try again

          await updateDocument({ prjid: project.itemId, docid: selectedDocument.itemId, pageCount: pageCount, pageNumbers: pageNumbers });
          status += 1;
          if (status > 2 && status <= attempts) {
            chunkSize = Math.ceil(chunkSize / 2);
          } else if (status > attempts) {
            //NOT COMPLETED in all attemps
            resultsStr = `Failed to complete full artefactisation in ${String(attempts)} attempts. Please try again.`;
          }
        } else { // Completed
          await updateDocument({ prjid: project.itemId, docid: selectedDocument.itemId, pageCount: pageCount, itemStatus: 2 });
          resultsStr = await getArtefactingResults();
          /*
          const arts = await getArtefacts();
          console.log(arts); // id md content
          resultsStr = "";
          for (const art of arts.data) {
            resultsStr +=  "ID: " + String(art.itemId) + "(" + art.content.id + + ") from page " + String(art.content.page) +"\n\n";
            resultsStr +=  String(art.content.md) + "\n\n";
            resultsStr +=  "Categories: " + String(art.content.categories) + "\n\n";
            resultsStr +=  "---------------------------------------------------------------------------------------------------------------------\n\n";
          }
            */
          status = attempts + 1;
        }

      } else {
        console.log("Mmm, why is it failing?");
        resultsStr = batchResults.error;
        status = attempts + 1;
      }

    }



    const secs = (Date.now() - uploadStatusRef.current.startTime) / 1000;
    setUploadStatus(prev => ({
      ...prev,
      isArtefacting: false,
      isUploading: false,
      resultsStatus: "artefactised (" + secs.toFixed(0) + " seconds)",
      regenArtifacts: false,
      regenSdos: false

    }));
    getDocs(selectedDocument.itemId, false);
    setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Artifacts");
    setResultsData(resultsStr);
    setResOpen(true);












    /*
        while (artStatus<2) {
          const result = await getOpenAI({type: 'artefactisation', docid: selectedDocument.itemId});
          message = result;
    
          if (result.statusCode==500) { // ERROR
            // delete all new records for the docid
            message = "ERROR: see below";
            if (result.findigCode && result.findigCode==6) {
              resultsStr = "OpenAI timed out - Artefaction is partially completed, restart to complete.";
            } else {
              resultsStr =  "OpenAI timed out - Artefaction is partially completed, restart to complete."; //result.body;
            }
            
            artStatus = 9;
            let cleanJsonString = result.body.replace(/```json|```/g, '').trim();
            // eslint-disable-next-line no-control-regex
            cleanJsonString = cleanJsonString.replace(/[\u0000-\u001F]+/g, "").replace(/\n/g, " ").trim();
            cleanJsonString = cleanJsonString.replace(/"\s*,/g, '",').replace(/"\s*}/g, '"}');
            const json = JSON.parse(cleanJsonString);
            resultsStr = JSON.stringify(json, null, 2);
          } else if (result.statusCode==200) {
            if (result.documentStatus) {
              artStatus = result.documentStatus;
              const status = "Completed: page " + String(result.page) + " of " + String(result.pages);
              console.log(status);
            } else {
              // MUST delete all new records for the docid
              result["extrainfo"] = "ERROR: no documentStatus in result with status 200";
              message = result;
              artStatus = 9;
            }
          }
        }
        const secs = (Date.now() - uploadStatusRef.current.startTime)/1000;
        if (artStatus==2) {
          message = "artefactised (" + secs.toFixed(0) + " seconds)";
        } else if (artStatus==9) {
          message = "OpenAI timed out - Artefaction is partially completed, restart to complete."; //`ERROR: ${artStatus}`;
        } else {
          message = "OpenAI timed out - Artefaction is partially completed, restart to complete."; //`ERROR: Terminated with incorrect artStatus: ${artStatus}`;
        }
        setUploadStatus(prev => ({
          ...prev,
          isArtefacting: false,
          isUploading: false,
          resultsStatus: message,
          regenArtifacts: (artStatus==2),
          regenSdos: false
      
        }));
        if (artStatus!=9) {
          const arts = await getArtefacts();
          console.log(arts); // id md content
          for (const art of arts.data) {
            resultsStr +=  "ID: " + String(art.itemId) + " from page " + String(art.page) +"\n\n";
            resultsStr +=  String(art.md) + "\n\n";
            resultsStr +=  "Categories: " + String(art.content) + "\n\n";
            resultsStr +=  "---------------------------------------------------------------------------------------------------------------------\n\n";
          }
          setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Artefacts");
        } else {
          setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Error");
        }
        //const resultsStr = JSON.stringify(arts.data, null, 2);
        getDocs(selectedDocument.itemId, false);
        setResultsData(resultsStr);
        setResOpen(true);
        */
  }


  const batchArtefactise = async (chunkSize) => {
    const result = await getDocument(selectedDocument.itemId);
    console.log(result);
    const pageNumbers = result.document.parseState.pageNumbers;
    const pageCount = result.document.parseState.totalPages;
    const limit = pLimit(10);
    const inputs = [];
    let openAiKeyId = 2;
    const unartefactisedPages = pageNumbers.filter(item => !item.artefactised);
    for (let offset = 0; offset < unartefactisedPages.length; offset += chunkSize) {
      const chunk = unartefactisedPages.slice(offset, offset + chunkSize);
      const pages = chunk.map(item => item.page);
      console.log(`Chunk IDs from ${offset} to ${offset + chunkSize - 1}:`, pages);
      inputs.push({ openAiKeyId: openAiKeyId, pages: pages });
      openAiKeyId = openAiKeyId == 1 ? 2 : 1; //alternate the keys
    }

    /*
        for (let i = 0; i<pageNumbers.length; i+=chunkSize) {
          //const pages = [];
          const startPageIdx = i;
          const endPageIdx = Math.min(i + chunkSize, pageNumbers.length);
          const pages = pageNumbers.slice(startPageIdx, endPageIdx);
          inputs.push({openAiKeyId: openAiKeyId, pages: pages});
          openAiKeyId = openAiKeyId==1?2:1; //alternate the keys
        }
          */
    const docid = selectedDocument.itemId;
    const limitedPromises = inputs.map(input => {
      const params = { type: 'artefactisation2', prjid: project.itemId, docid: docid, keyId: input.openAiKeyId, pages: input.pages };
      console.log(params);
      return limit(() => getOpenAI(params))
    }
    )
    try {
      const results = await Promise.all(limitedPromises);
      console.log(results);
      return { success: true, data: results, pageNumbers: pageNumbers, pageCount: pageCount };
    } catch (err) {
      console.error("Some call failed", err);
      return { success: false, error: err };
    }
  }


  const artifactise = async (isRegen) => {
    if (isRegen) {
      setUploadStatus(prev => ({
        ...prev,
        resultsStatus: uploadStatus.resultsStatus + "artefacting"
      }));
    } else {
      setUploadStatus(prev => ({
        ...prev,
        resultsStatus: "artefacting",
        startTime: Date.now(),
        isUploading: true
      }));
    }

    let artStatus = 0;
    let message;
    let resultsStr = "";
    while (artStatus < 2) {
      const result = await getOpenAI({ type: 'artefactisation', prjid: project.itemId, docid: selectedDocument.itemId });
      message = result;

      if (result.statusCode == 500) { // ERROR
        // delete all new records for the docid
        message = "ERROR: see below";
        if (result.findigCode && result.findigCode == 6) {
          resultsStr = "OpenAI timed out - Artefaction is partially completed, restart to complete.";
        } else {
          resultsStr = "OpenAI timed out - Artefaction is partially completed, restart to complete."; //result.body;
        }

        artStatus = 9;
        let cleanJsonString = result.body.replace(/```json|```/g, '').trim();
        // eslint-disable-next-line no-control-regex
        cleanJsonString = cleanJsonString.replace(/[\u0000-\u001F]+/g, "").replace(/\n/g, " ").trim();
        cleanJsonString = cleanJsonString.replace(/"\s*,/g, '",').replace(/"\s*}/g, '"}');
        const json = JSON.parse(cleanJsonString);
        resultsStr = JSON.stringify(json, null, 2);
      } else if (result.statusCode == 200) {
        if (result.documentStatus) {
          artStatus = result.documentStatus;
          const status = "Completed: page " + String(result.page) + " of " + String(result.pages);
          console.log(status);
        } else {
          // MUST delete all new records for the docid
          result["extrainfo"] = "ERROR: no documentStatus in result with status 200";
          message = result;
          artStatus = 9;
        }
      }
    }
    const secs = (Date.now() - uploadStatusRef.current.startTime) / 1000;
    if (artStatus == 2) {
      message = "artefactised (" + secs.toFixed(0) + " seconds)";
    } else if (artStatus == 9) {
      message = "OpenAI timed out - Artefaction is partially completed, restart to complete."; //`ERROR: ${artStatus}`;
    } else {
      message = "OpenAI timed out - Artefaction is partially completed, restart to complete."; //`ERROR: Terminated with incorrect artStatus: ${artStatus}`;
    }
    setUploadStatus(prev => ({
      ...prev,
      isArtefacting: false,
      isUploading: false,
      /*parsingStatus: uploadStatusRef.current.parsingStatus+"complete!",*/
      resultsStatus: message,
      regenArtifacts: (artStatus == 2),
      regenSdos: false

    }));
    if (artStatus != 9) {
      const arts = await getArtefacts();
      console.log(arts); // id md content
      for (const art of arts.data) {
        resultsStr += "ID: " + String(art.itemId) + " from page " + String(art.page) + "\n\n";
        resultsStr += String(art.md) + "\n\n";
        resultsStr += "Categories: " + String(art.content) + "\n\n";
        resultsStr += "---------------------------------------------------------------------------------------------------------------------\n\n";
      }
      setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Artefacts");
    } else {
      setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Error");
    }
    //const resultsStr = JSON.stringify(arts.data, null, 2);
    getDocs(selectedDocument.itemId, false);
    setResultsData(resultsStr);
    setResOpen(true);
  }

  const getDocs = async (id, setResults) => {
    const result = await getDocuments();
    const docs = result.data;
    docs.sort((a, b) => {
      const nameCompare = a.name.localeCompare(b.name);
      if (nameCompare !== 0) {
        return nameCompare; // sort by name first
      }
      return a.version - b.version; // then by priority
    });
    setDocuments(docs);
    if (id && id != "") {
      const seldoc = result.data.filter(doc => doc.itemId == id);
      //console.log(id);
      setSelectedDocument(seldoc[0]);
      let resultsStr = seldoc[0].content;
      if (setResults) {
        try {
          let cleanJsonString = resultsStr.replace(/```json|```/g, '').trim();
          // eslint-disable-next-line no-control-regex
          cleanJsonString = cleanJsonString.replace(/[\u0000-\u001F]+/g, "").replace(/\n/g, " ").trim();
          cleanJsonString = cleanJsonString.replace(/"\s*,/g, '",').replace(/"\s*}/g, '"}');

          const obj = JSON.parse(cleanJsonString);
          resultsStr = JSON.stringify(obj, null, 2);
        } catch (e) {
          console.log("JSON.parse failed: ", e.message);
        }
        //setResultsTitle("Document Metadata");
        setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Document Metadata");
        setResultsData(resultsStr);
      }
    } else {
      setSelectedDocument(result.data[0]);
    }
    //console.log(result);
  }

  const loadConfig = async () => {
    const result = await getConfig();
    console.log(result);
    let config;
    let cats;
    for (let i = 0; i < result.data.length; i++) {
      const val = result.data[i];
      switch (val.sk) {
        case "ALL|OPT":
          config = val.content;
          break;
        case "ALL|CAT":
          cats = val.content;
          break;
        case "ALL|OUT":
          // no nowt
          break;
      }
    }
    setFullCats(cats);
    if (config) {
      if (config.chunkSize) {
        setArtPageNo(config.chunkSize);
      }
      if (config.selectedParseModel) {
        setSelectedParseModel(config.selectedParseModel);
      }
      if (config.selectedArtefactModel) {
        setSelectedArtefactModel(config.selectedArtefactModel);
      }
      if (config.selectedExtractModel) {
        setSelectedExtractModel(config.selectedExtractModel);
      }
      if (config.parsePromptUser) {
        setParsePromptUser(config.parsePromptUser);
      }
      if (config.parsePromptSys) {
        setParsePromptSys(config.parsePromptSys);
      }
      if (config.artePromptUser) {
        setArtePromptUser(config.artePromptUser);
      }
      if (config.artePromptSys) {
        setArtePromptSys(config.artePromptSys);
      }
      if (config.extractPromptUser) {
        setExtractPromptUser(config.extractPromptUser);
      }
      if (config.extractPromptSys) {
        setExtractPromptSys(config.extractPromptSys);
      }
      if (config.metaPromptUser) {
        setMetaPromptUser(config.metaPromptUser);
      }
      if (config.metaPromptSys) {
        setMetaPromptSys(config.metaPromptSys);
      }
    }
  }


  const doQuery = async (e) => {
    e.preventDefault();
    setUploadStatus(prev => ({
      ...prev,
      resultsStatus: "querying",
      startTime: Date.now(),
      isQuerying: false,
      isUploading: true
    }));

    if (uploadStatus.isUploading) {
      return;
    }
    setUploadStatus(prev => ({
      ...prev,
      isUploading: true,
    }));
    if (selectedCategories && selectedCategories.length < 1) {
      alert("Please select at least one category.");
      return;
    }
    if (!prompt.includes("{{{artefacts}}}")) {
      alert("Please include {{{artefacts}}} in the user prompt.");
      return;
    }
    if (prompt == "" || sysPrompt == "") {
      alert("System and/or user prompts missing");
      return;
    }
    let allNumbers = [];
    for (const cat in selectedCategories) {
      console.log(selectedCategories[cat]);
      console.log(categories[selectedCategories[cat]]);
      const ids = categories[selectedCategories[cat]].artefactIds;
      // Merge & deduplicate
      allNumbers = [...allNumbers, ...ids];
    }
    const uniqueIds = [...new Set(allNumbers)];
    console.log(uniqueIds);
    const uniqueSortedNumbers = [...new Set(allNumbers)].sort((a, b) => a - b);
    console.log(uniqueSortedNumbers);
    let resultsStr = "";
    try {
      const result = await getOpenAI({ prjid: project.itemId, docId: selectedDocument.itemId, cats: uniqueSortedNumbers, prompt: prompt, sysPrompt: sysPrompt, model: selectedModel });
      console.log(result);
      resultsStr = result.data;
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
    }
    const secs = (Date.now() - uploadStatusRef.current.startTime) / 1000;

    const message = "queried (" + secs.toFixed(0) + " seconds)";

    setUploadStatus(prev => ({
      ...prev,
      isUploading: false,
      resultsStatus: message
    }));
    setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Query results");
    setResultsData(resultsStr);
    setResOpen(true);
  }

  const doQuery2 = async (e) => {
    console.log("aaa");
    e.preventDefault();
    console.log('aaa');
    setUploadStatus(prev => ({
      ...prev,
      resultsStatus: "querying",
      startTime: Date.now(),
      isFreeQuerying: true,
      isUploading: true
    }));

    if (uploadStatus.isUploading) {
      return;
    }
    setUploadStatus(prev => ({
      ...prev,
      isUploading: true,
    }));
    if (sysPrompt == "") {
      alert("Prompt missing");
      return;
    }
    let resultsStr = "";
    console.log('bbb');
    console.log({ type: "freeQuery", prjid: 1111, sysPrompt: sysPrompt, model: selectedModel, isFreeQuery: true });
    try {


  /*const [temperature, setTemperature] = useState(0.0);
  const [topP, setTopP] = useState(1.0);
  const [presencePenalty, setPresencePenalty] = useState(0.0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);*/


      const result = await getOpenAI({ type: "freeQuery", prjid: 1111, sysPrompt: sysPrompt, model: selectedModel, temperature, topP, presencePenalty, frequencyPenalty, isFreeQuery: true });






      console.log(result);
      resultsStr = result.data;
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
    }
    const secs = (Date.now() - uploadStatusRef.current.startTime) / 1000;

    const message = "queried (" + secs.toFixed(0) + " seconds)";

    setUploadStatus(prev => ({
      ...prev,
      isUploading: false,
      resultsStatus: message
    }));
    setResultsTitle("Free Query results");
    setResultsData(resultsStr);
    setResOpen(true);
  }


  const showDocResults = async (e) => {
    e.preventDefault();
    resetResults();
    let resultsStr = selectedDocument.content;
    try {
      let cleanJsonString = resultsStr.replace(/```json|```/g, '').trim();
      // eslint-disable-next-line no-control-regex
      cleanJsonString = cleanJsonString.replace(/[\u0000-\u001F]+/g, "").replace(/\n/g, " ").trim();
      cleanJsonString = cleanJsonString.replace(/"\s*,/g, '",').replace(/"\s*}/g, '"}');

      const obj = JSON.parse(cleanJsonString);
      resultsStr = JSON.stringify(obj, null, 2);
    } catch (e) {
      console.log("JSON.parse failed: ", e.message);
    }
    setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Document Metadata");
    setResultsData(resultsStr);
    setResOpen(true);
  }
  const showArtResults = async (e) => {
    e.preventDefault();
    resetResults();

    const resultsStr = await getArtefactingResults();

    /*
    const arts = await getArtefacts();
    let resultsStr = "";
    for (const art of arts.data) {
      resultsStr +=  "ID: " + String(art.itemId) + " from page " + String(art.page) +"\n\n";
      resultsStr +=  String(art.md) + "\n\n";
      resultsStr +=  "Categories: " + String(art.content) + "\n\n";
      resultsStr +=  "---------------------------------------------------------------------------------------------------------------------\n\n";
    }
      */
    setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Artefacts");
    setResultsData(resultsStr);
    setUploadStatus(prev => ({
      ...prev,
      regenArtifacts: true,
      regenSdos: false
    }));
    setResOpen(true);

  }

  const showExtractResults = async (e) => {
    e.preventDefault();
    resetResults();
    const resultsStr = await getSDOList();
    setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Structured Data Objects");
    setResultsData(resultsStr);
    setUploadStatus(prev => ({
      ...prev,
      regenArtifacts: false,
      regenSdos: true
    }));
    setResOpen(true);

  }


  const getArtefactingResults = async () => {
    const arts = await getArtefacts();
    let resultsStr = "";
    for (const art of arts.data) {
      resultsStr += "ID: " + String(art.itemId) + "(" + art.content.id + ") from page " + String(art.content.page) + "\n\n";
      resultsStr += String(art.content.md) + "\n\n";
      resultsStr += "Categories: " + String(art.content.categories) + "\n\n";
      resultsStr += "---------------------------------------------------------------------------------------------------------------------\n\n";
    }
    return resultsStr;
  }

  const copyToClipboard = (e) => {
    navigator.clipboard.writeText(resultsData)
      .then(() => {
        console.log("Text copied to clipboard!");
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // hide after 2 sec
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  }

  const handleArtPageNoChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue > 100) newValue = 10;
    if (newValue < 1) newValue = 1;
    setArtPageNo(newValue);
  }


  const uploadDocument = async (e) => {
    e.preventDefault();
    resetResults();
    saveConfig();
    uploadParseDoc();
  }
  const artifactiseDocument = async (e) => {
    e.preventDefault();
    resetResults();
    saveConfig();
    //artifactise(false);
    artifactise2(false);
  }
  const extractDocument = async (e) => {
    e.preventDefault();
    resetResults();
    saveConfig();
    sdoExtraction(false);
  }

  const queryStuff = async (e) => {
    e.preventDefault();
    setSelectedCategories([]);
    resetResults();
    //const fullCats = JSON.parse(categoriesStr);
    console.log(fullCats);
    const cats = selectedDocument.parseState.categories; //JSON.parse(selectedDocument.categories);
    console.log(cats);
    let catOpts = [];
    let idx = 0;
    let catidx = 0;
    for (const cat in fullCats) {
      console.log(cat);
      const col = catidx < 3 ? 0 : catidx < 7 ? 1 : 2;
      catOpts.push({ key: idx, label: cat + " " + fullCats[cat].title, artefactIds: null, status: 0, col: col });
      idx++;
      catidx++;
      for (const subcat in fullCats[cat].subsections) {
        const items = cats[subcat];
        catOpts.push({ key: idx, label: subcat + " " + fullCats[cat].subsections[subcat].title, artefactIds: items, status: items ? 1 : 9, col: col });
        idx++;
      }
    }
    const colArr = Array.from({ length: 3 }, () => []);
    catOpts.forEach((catItem, index) => {
      //console.log(catItem);
      colArr[catItem.col].push(catItem);
    });
    setCatCols(colArr);
    setCategories(catOpts);
    setUploadStatus(prev => ({
      ...prev,
      isQuerying: true
    }));
  }


  const queryStuff2 = async (e) => {
    e.preventDefault();

    setSelectedCategories([]);
    resetResults();

    setUploadStatus(prev => ({
      ...prev,
      isFreeQuerying: true
    }));
  }




  const cancelAll = async (e) => {
    e.preventDefault();
    resetResults();
    if (isReadyToUpload) {
      setIsReadyToUpload(false);
      setFileDetails(null);
      setDocuments(prevDocs => prevDocs.filter(doc => doc.itemId !== "NEW"));
      setSelectedDocument(documents[0]);
      setIsReadyToUpload(false);
    }
    setUploadStatus(prev => ({
      ...prev,
      isUploading: false,
      isQuerying: false,
      isFreeQuerying: false
    }));



  }

  const clearResults = async (e) => {
    e.preventDefault();
    resetResults();
  }

  function resetResults() {
    setResultsTitle('');
    setResultsData('');
    setUploadStatus(prev => ({
      ...prev,
      resultsStatus: "",
      isQuerying: false,
      regenArtifacts: false,
      regenSdos: false
    }));
    setResOpen(false);
  }




  const openFileDialog = () => {
    const input = document.getElementById("upload-data");
    input.value = ""; // Reset the input to allow re-selection of the same file
    //input.click();
  };

  function renderActionLander() {
    return (
      <>
        <Box p={0} >

          <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' >
            <Box p={0.5} >
              <h4><b>{fileDetails && fileDetails.file.name}</b>&nbsp;&nbsp;v.{fileDetails && fileDetails.version}</h4>


            </Box>



          </Box>


        </Box>
        <Box mt={1} mb={5}>
          <Paper>



            <Box p={1} display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' >
              <Box pv={2} >
                <h5><b>Parsing</b></h5>
              </Box>
              <Box pv={2} >
                <h5><b>{uploadStatus.parsingStatus && uploadStatus.parsingStatus}</b></h5>
              </Box>
            </Box>


            <Box p={1} display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' >
              <Box pv={2} >
                <h5><b>Artefacting</b></h5>
              </Box>
              <Box pv={2} >
                <h5><b>{uploadStatus.artefactingStatus && uploadStatus.artefactingStatus}</b></h5>
              </Box>
            </Box>


            <Box p={1} display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' >
              <Box pv={2} >
                <h5><b>Extracting</b></h5>
              </Box>
              <Box pv={2} >
                <h5><b> </b></h5>
              </Box>
            </Box>


          </Paper>


        </Box>


      </>
    )
  };




  function renderLander() {
    return (

      <>
        {uploadStatus.isFreeQuerying &&
          <Paper style={{ backgroundColor: "#fbeee6" }}>
            <Box p={1} >





              <Typography variant="body2" >
                <u>Prompt</u>
              </Typography>

              <TextareaAutosize
                value={sysPrompt}
                onChange={(e) => setSysPrompt(e.target.value)}
                minRows={25}
                maxRows={100}
                style={{
                  width: '100%',
                  padding: 8,
                  fontSize: 16,
                  borderRadius: 4,
                  border: '1px solid #ccc',
                }}
                placeholder="prompt..."
              />


              <Box my={2} >
                <select
                  id="model"
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                >
                  {models.map((model) => (
                    <option key={model.value} value={model.value}>
                      {model.label}
                    </option>
                  ))}
                </select>
              </Box>

<Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>
                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              //disabled={isRunning}
                              value={temperature}
                              onChange={handleTemperatureChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Temperature</h6>
                        </Box>
                      </Box>

                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              //disabled={isRunning}
                              value={topP}
                              onChange={handleTopPChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Top P</h6>
                        </Box>
                      </Box>

                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              //disabled={isRunning}
                              value={presencePenalty}
                              onChange={handlePresencePenaltyChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Presence penalty</h6>
                        </Box>
                      </Box>
                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              //disabled={isRunning}
                              value={frequencyPenalty}
                              onChange={handleFrequencyPenaltyChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Frequency penalty</h6>
                        </Box>
                      </Box>


              <Box mb={1} display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' >
                <Box sx={{ flexGrow: 1 }} ></Box>
                <Box mx={2}>
                  <Button onClick={doQuery2} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Run Query</Button>
                </Box>
                <Button onClick={cancelAll} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Cancel</Button>
              </Box>
            </Box>
          </Paper>


        }









        <Box mt={1}>
          <Paper style={{ backgroundColor: "#e8f6f3" }}>
            <Box p={1} >
              <Box display="flex" alignItems='center' flexDirection="row" >
                <Box py={0} >
                  <h5><b>Results</b></h5>
                </Box>

                <Box mx={1} pb={1}>
                  <Tooltip title="Copy results to clipboard">

                    <IconButton
                      onClick={copyToClipboard}
                      disabled={false}
                      size="small"
                    >
                      <FileCopyIcon />
                    </IconButton>

                  </Tooltip>
                  {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                </Box>




                <Box mx={1} pb={1}>
                  <Tooltip title="Regenerate">

                    <IconButton
                      onClick={() => setWarnRegenerate(true)}
                      disabled={!(uploadStatus.regenArtifacts || uploadStatus.regenSdos)}
                      size="small"
                    >
                      <SyncIcon />
                    </IconButton>






                  </Tooltip>

                </Box>



                <Box mx={1} pb={1}>
                  <Tooltip title="Clear results">

                    <IconButton
                      onClick={clearResults}
                      disabled={false}
                      size="small"
                    >
                      <CancelIcon />
                    </IconButton>


                  </Tooltip>

                </Box>
                <Box pv={0} >
                  <Typography variant="body2" style={{ color: 'green', fontSize: '0.8rem' }}>
                    &nbsp;&nbsp;&nbsp;{uploadStatus && uploadStatus.resultsStatus}
                  </Typography>

                </Box>



                <Box sx={{ flexGrow: 1 }} ></Box>
                <ExpandMore
                  color="primary"
                  expand={resOpen}
                  onClick={() => { setResOpen(!resOpen) }}
                  aria-expanded={resOpen}
                  aria-label="show results"
                  size="small"
                  id="resOpen">
                  <ExpandMoreIcon />
                </ExpandMore>
              </Box>
              <Collapse in={resOpen} timeout="auto" unmountOnExit>
                {/*{uploadStatus && !uploadStatus.isUploading && */}
                <>

                  <h6><u>{resultsTitle}</u></h6>
                  <Box m={2}>
                    <Paper>
                      <Box m={1} py={1}>
                        <div style={{ whiteSpace: 'pre-wrap' }}>{resultsData}</div>
                      </Box>
                    </Paper>
                  </Box>
                </>
              </Collapse>
            </Box>

          </Paper>
        </Box>


      </>


    )
  }


  return (

    <div className="Sites">
      {/*isLoading ? renderLoader() : ((isArtefacting || isParsing)?renderActionLander:renderLander())*/}
      {isLoading ? renderLoader() : renderLander()}
      <Dialog
        open={fileDetails && fileDetails.isDuplicate && !isReadyToUpload}
        fullWidth={false}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" style={{ color: "#10385A" }} >
          Document Upload
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            A file with the same name (<b>{fileDetails && fileDetails.file.name}</b>) has already been uploaded. Click CONTINUE to continue with the upload creating a new version (<b>v.{fileDetails && fileDetails.version}</b>) of the document.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => {
            setFileDetails(null);
            setDocuments(prevDocs => prevDocs.filter(doc => doc.itemId !== "NEW"));
            setSelectedDocument(documents[0]);
          }} color="primary">
            Cancel
          </Button>
          <Button onClick={continueFileUpload} color="secondary">
            CONTINUE
          </Button>
        </DialogActions>
      </Dialog>





      <Dialog
        open={warnRegenerate}
        fullWidth={false}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" style={{ color: "#10385A" }} >
          {uploadStatus.regenArtifacts ? "Regenerate Artifacts and related SDOs" : "Regenerate SDOs"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Warning: this will delete the existing {uploadStatus.regenArtifacts ? " Artifacts and their related SDOs" : "SDOs"} for the current document. Do you wish to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => {
            setWarnRegenerate(false);
          }}
            color="primary">
            Cancel
          </Button>
          <Button onClick={continueRegenerate} color="secondary">
            CONTINUE
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={uploadStatus && uploadStatus.isComplete}
        fullWidth={false}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" style={{ color: "#10385A" }} >
          Document Upload
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {/*uploadStatus && uploadStatus.artefactingStatus*/}
            Completed OK!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => {
            setFileDetails(null);
            setIsReadyToUpload(false);
            setUploadStatus(prev => ({
              ...prev,
              isUploading: false,
              artefactingStatus: "",
              parsingStatus: "",
              extractingStatus: "",
              isExtracting: false,
              isArtefacting: false,
              isComplete: false
            }));
          }} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

